var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var WidgetConfigError = /** @class */ (function (_super) {
    __extends(WidgetConfigError, _super);
    function WidgetConfigError(message) {
        var _this = _super.call(this, message) || this;
        _this.widget_config = true;
        return _this;
    }
    return WidgetConfigError;
}(Error));
export { WidgetConfigError };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiV2lkZ2V0Q29uZmlnRXJyb3IuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvZmVhdHVyZXMvbW9uaXRvcmluZy9lcnJvcnMvV2lkZ2V0Q29uZmlnRXJyb3IudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7O0FBQUE7SUFBdUMscUNBQUs7SUFHMUMsMkJBQVksT0FBTztRQUFuQixZQUNFLGtCQUFNLE9BQU8sQ0FBQyxTQUNmO1FBSkQsbUJBQWEsR0FBWSxJQUFJLENBQUM7O0lBSTlCLENBQUM7SUFDSCx3QkFBQztBQUFELENBQUMsQUFORCxDQUF1QyxLQUFLLEdBTTNDIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGNsYXNzIFdpZGdldENvbmZpZ0Vycm9yIGV4dGVuZHMgRXJyb3Ige1xuICB3aWRnZXRfY29uZmlnOiBib29sZWFuID0gdHJ1ZTtcblxuICBjb25zdHJ1Y3RvcihtZXNzYWdlKSB7XG4gICAgc3VwZXIobWVzc2FnZSk7XG4gIH1cbn1cbiJdfQ==